import { defineStore } from "pinia";

const defaultState = {
  commonPrice: '0',
  cargoVolume: 0,
  totalWeight: 0,
  transportation: 0,
  cargoPickUp: 0,
  extraChargeForCargoPickUp: 0,
  extraChargeForCargoDelivery: 0,
  costForReturningDocuments: 0,
  cargoDelivery: 0,
  package: 0,
  costWarranty: 0,
  costForTheRedemptionOfCargo: 0,
  cashOnDeliveryAmount: 0,
  warmPlace: false,
  shippingCost: 0,
  officeFromAddress: "",
  officeToAddress: "",
  sumText: "0",
  currencyKZ: 0,
  currencyCountry: "ru",
}
export const useDataFormStoreApi = defineStore({
  id: "dataFormApi",
  state: () => ({ ...defaultState }),
  actions: {
    currencyCount(cost) {
      return  Number((cost*(this.currencyCountry == "kz" ? this.currencyKZ : 1)).toFixed(2));
    },
    reset() {
      Object.assign(this, defaultState);
    }
  }
});
